import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  padding: ${(p) => p.theme.spacing(0.5, 0)};
`;
